import { c as _c } from "react/compiler-runtime";
import React from 'react';
import classNames from 'classnames';
import { useI18n } from '@udemy-v2/i18n';
import { ClpPrimaryCtaButton } from '@/features/course-landing-page/components/clp-primary-cta-button/clp-primary-cta-button.react-component';
import styles from './clp-subscription-unpause.module.scss';

/**
 * Shown instead of any purchase/upgrade option when the user's subscription is paused.
 * The CTA button itself comes from useClpPrimaryCtaButton (re-activate link).
 */
export const ClpSubscriptionUnpause = () => {
  const $ = _c(8);
  const {
    gettext
  } = useI18n();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = classNames("ud-text-md", styles.text);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== gettext) {
    t1 = gettext("Your subscription is paused. Reactivate it to keep learning.");
    $[1] = gettext;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <p className={t0}>{t1}</p>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ClpPrimaryCtaButton udStyle="primary" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2) {
    t4 = <div className={styles.container} data-purpose="clp-subscription-unpause">{t2}{t3}</div>;
    $[6] = t2;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};